import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const DescriptionList = styled.dl(props => ({
    fontSize: "16px",
    lineHeight: "20px",
    color: theme(props).typography.primary.color,
}));

export const DescriptionName = styled.dt({
    float: "left",
    width: "100px",
    padding: "0 0 10px",
});

export const DescriptionTerm = styled.dd({
    marginLeft: 110,
    padding: "0 0 10px",
});
